export const SITE_URL = "https://mizubrunch.hu";
export const SITE_NAME = "Mizu Brunch & Coffee";
export const OG_IMAGE = `${SITE_URL}/img/mizulogo.png`;

export const seoCopy = {
  hu: {
    title: "Mizu Brunch & Coffee – Reggeli és brunch Budapest XIII. kerületében",
    description:
      "Kávézó és brunch Budapest XIII. kerületében — reggeli, specialty kávé és hangulatos hely a Fáy utca 75-ön. Hétfőtől vasárnapig 7:00–17:30.",
    keywords:
      "kávézó Budapest, brunch Budapest, reggeli Budapest, specialty kávé Budapest, kávézó XIII. kerület, brunch XIII. kerület, Angyalföld kávézó, reggeliző Budapest, coffee shop Budapest, Mizu Brunch, Fáy utca",
    ogLocale: "hu_HU",
  },
  en: {
    title: "Mizu | We're Open! — Brunch & Coffee Budapest",
    description:
      "Coffee shop and brunch in Budapest District 13 — breakfast, specialty coffee, and a cozy spot at Fáy utca 75. Mon–Sun 7:00 AM–5:30 PM.",
    keywords:
      "coffee shop Budapest, brunch Budapest, breakfast Budapest, specialty coffee Budapest, cafe District 13 Budapest, Angyalfold cafe, best brunch Budapest, Mizu Brunch, Fay utca",
    ogLocale: "en_GB",
  },
};

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "CafeOrCoffeeShop",
  name: SITE_NAME,
  url: SITE_URL,
  image: OG_IMAGE,
  email: "info@mizubrunch.hu",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Fáy utca 75",
    addressLocality: "Budapest",
    postalCode: "1135",
    addressCountry: "HU",
  },
  sameAs: ["https://www.instagram.com/mizubudapest/"],
  servesCuisine: ["Brunch", "Coffee"],
  priceRange: "$$",
};

function setMeta(attr, key, content) {
  if (!content) return;

  let element = document.head.querySelector(`meta[${attr}="${key}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;

  let element = document.head.querySelector(`link[rel="${rel}"]`);

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
}

export function applySeo(lang) {
  const locale = lang === "en" ? "en" : "hu";
  const copy = seoCopy[locale];

  document.documentElement.lang = locale;
  document.title = copy.title;

  setMeta("name", "description", copy.description);
  setMeta("name", "keywords", copy.keywords);
  setMeta("name", "author", SITE_NAME);
  setMeta("name", "robots", "index, follow");
  setMeta("name", "theme-color", "#fdf8f0");

  setLink("canonical", SITE_URL);

  setMeta("property", "og:type", "website");
  setMeta("property", "og:site_name", SITE_NAME);
  setMeta("property", "og:title", copy.title);
  setMeta("property", "og:description", copy.description);
  setMeta("property", "og:url", SITE_URL);
  setMeta("property", "og:image", OG_IMAGE);
  setMeta("property", "og:locale", copy.ogLocale);

  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", copy.title);
  setMeta("name", "twitter:description", copy.description);
  setMeta("name", "twitter:image", OG_IMAGE);

  let schema = document.getElementById("mizu-jsonld");

  if (!schema) {
    schema = document.createElement("script");
    schema.id = "mizu-jsonld";
    schema.type = "application/ld+json";
    document.head.appendChild(schema);
  }

  schema.textContent = JSON.stringify({
    ...jsonLd,
    description: copy.description,
  });
}

export function initSeo(lang = "hu") {
  applySeo(lang);
}
